export default {
    GOOGLE_PUBLIC_KEY: 'AIzaSyAI2EPl1gjT7hZziI8XfZeLbBQUod7QMM8'
}
